(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("dataMiningService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 812,
                    parameters: parms || {}
                });
            },
            listGroupings: function (parms) {
                return $ihttp.post({
                    method: 813,
                    parameters: parms || {}
                });
            },
            listNumbers: function (parms) {
                return $ihttp.post({
                    method: 814,
                    parameters: parms || {}
                });
            },
            listMiningDatas: function (parms) {
                return $ihttp.post({
                    method: 815,
                    parameters: parms || {}
                });
            },
            addNextLevel: function (edit) {
                return $ihttp.post({
                    method: 816,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
